import React from 'react'
import Well from '@react/react-spectrum/Well'

export default function IntegrationNpm () {
    return <div>
        <p>Integration - HTML</p>
        <Well>
            npm install remove-background-standalone<br /><br />
            import &#x2774; ImageCutout &#x2775; from '@adobe/remove-background-standalone'<br /><br />
        </Well>
    </div>
}
